<template>
  <hm-content title="">
    <div class="mb10">
      <el-radio-group
        v-model="searchConditions.state"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="wait">待处理</el-radio-button>
        <el-radio-button label="success">已补写</el-radio-button>
        <el-radio-button label="ignore">已忽略</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table-panel flex flex-end">
      <el-date-picker
        size="small"
        clearable
        class="mr10"
        v-model="searchConditions.date"
        ref="datepicker"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        type="datetimerange"
        range-separator="至"
        start-placeholder="销售开始日期"
        end-placeholder="销售结束日期"
      ></el-date-picker>
      <el-input
        clearable
        v-model.trim="searchConditions.receiptSn"
        placeholder="输入订单号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        type="number"
        clearable
        v-model.trim="searchConditions.memberMobile"
        placeholder="输入会员手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="list"
        style="width: 100%"
        id="table"
        ref="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <!-- <el-table-column header-align="center" prop="orderOfflineId" align="center" label="线下订单号">
        </el-table-column>-->
        <el-table-column
          header-align="center"
          prop="receiptSn"
          align="center"
          label="订单号"
        ></el-table-column>
        <el-table-column
            header-align="center"
            prop="subOrderSn"
            align="center"
            label="子订单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="purchaseTime"
          align="center"
          label="订单销售时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="shopName"
          align="center"
          label="发货门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="actuallyPrice"
          align="center"
          label="订单总额"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.actuallyPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="memberName"
          align="center"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="memberMobile"
          align="center"
          label="会员电话"
        ></el-table-column>
        <el-table-column
            header-align="center"
            prop="remark"
            align="center"
            label="请求参数"
        >
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.remark" placement="left">
            <span class="text-overflow">{{
                scope.row.remark
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            prop="errorMsg"
            align="center"
            label="异常原因"
        >
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.errorMsg" placement="left">
            <span class="text-overflow">{{
                scope.row.errorMsg
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          v-if="searchConditions.state === 'wait'"
        >
          <template slot-scope="scope">
            <div>
              <el-button @click="write(scope.row)" size="small" type="text"
              >补写</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button @click="hulue(scope.row)" size="small" type="text"
              >忽略</el-button
              >
            </div>
          </template>
          <!-- <template slot-scope="scope" v-else>
            <div>
              <el-button @click="operate(scope.row)" size="small" type="text"
                >操作</el-button
              >
            </div>
          </template> -->
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-size="pageSize"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
export default {
  components: {},
  data() {
    return {
      successRow: "",
      dialogVisibleSuccess: false,
      dialogVisibleWrite: false,
      goodslist: [],
      title: "",
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      searchConditions: {
        state: "wait",
        date: [],
      },
      row: {},
      // 是否显示操作
      operationType: false,
      multiGoodslist: [], // 合并单元格表格数据
      multiDialogVisible: false, // 操作表格弹窗
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    hulue(row) {
      this.writeOrder("ignore",row);
    },
    async writeOrder(operationType,row) {
      console.log("row:",row)
      let params = {
        id: row.id,
        operationType,
      };
      let { code, result } = await this.$store.dispatch(
          "overSeasOrderPushErrorHandle",
          params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success",
        });
        this.queryList();
      }
      if (this.isOperate) {
        this.operate(this.row)
      }
    },
    write(row) {
      this.row = row;
      this.writeOrder("repaired",row);
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList().then(() => {
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          //给table加一个ref
        });
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchConditions));
      searchCondition.queryStartTime = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";

      Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "overSeasExceptionOrderList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
  },
};
</script>
<style lang="scss" scoped>
.info {
  .title {
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.font-style {
  font-weight: bold;
  font-size: 18px;
  line-height: 25px;
}
</style>
